// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Supported and common values of FormRecognizerApiVersion.
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var FormRecognizerApiVersion = {
  /**
   * The newest version of the service known to be supported by the client (default).
   *
   * If using a beta package version, this will be identical to the latest preview version. Otherwise, it will be
   * identical to the latest stable version.
   */
  Latest: "2022-06-30-preview" // TODO (GA): Add a `Stable` version selector that picks the latest GA version, even in beta packages, and an exact
  // version entry for the GA version.

};
/**
 * Supported values of StringIndexType.
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare

export var StringIndexType = {
  /**
   * UTF-16 code units
   */
  Utf16CodeUnit: "utf16CodeUnit",

  /**
   * Unicode code points
   */
  UnicodeCodePoint: "unicodeCodePoint"
};
/**
 * Default settings for Form Recognizer clients.
 *
 * @internal
 */

export var DEFAULT_GENERATED_CLIENT_OPTIONS = {
  stringIndexType: StringIndexType.Utf16CodeUnit,
  apiVersion: FormRecognizerApiVersion.Latest
};